/**
 * 1386.4 → "R$ 1.386,40". Com separador de milhar: o resumo do dia mostrava
 * "R$ 1386,40" (achado 345). O Intl põe espaço não separável depois do R$;
 * troca por espaço comum para sair igual ao resto do painel.
 */
export function formatarReais(valor) {
  return Number(valor || 0)
    .toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
    .replace(/ /g, " ");
}
